<template>
    <form method='post' :action="url" id="vue-form"></form>
</template>

<script>

const succesUrl = window.groovie.succes_url;

export default {
    name: 'cash',
    props: {},
    data() {
        return {
            url: succesUrl
        };
    }
};
</script>




// WEBPACK FOOTER //
// src/components/Cash.vue